import React from "react";

const Loader = () => {
  return (
    <div className="loader-wrapper">
      <div className="spinner-border text-primary" role="status">
          <img src="/assets/img/loader_1.gif" />
      </div>
    </div>
  );
};

export default Loader;
